import { useUI } from '@/stores/ui'
import { cn } from '@/utils/cn'

function Toast() {
  const { toasts, removeToast } = useUI()

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className={cn(
            'animate-fade-in min-w-[300px] max-w-md p-4 rounded-xl shadow-lg',
            'bg-white border-2',
            {
              'border-green-500 bg-green-50': toast.type === 'success',
              'border-red-500 bg-red-50': toast.type === 'error',
              'border-blue-500 bg-blue-50': toast.type === 'info',
              'border-yellow-500 bg-yellow-50': toast.type === 'warning',
            }
          )}
          >
            <div className="flex items-start justify-between">
              <p className="text-sm font-medium text-gray-900">{toast.message}</p>
              <button
                onClick={() => removeToast(toast.id)}
                className="ml-4 text-gray-400 hover:text-gray-600"
              >
                ×
              </button>
            </div>
          </div>
        ))}
    </div>
  )
}

export default Toast
